export default class NotAuthenticatedError {
  
}